const walkDOM = function (node, cb) {
  cb(node);

  node.childNodes.forEach((n) => {
    walkDOM(n, cb);
  });
};

const toNodes = html => new DOMParser().parseFromString(html, "text/html").body.childNodes[0];

const splitAndHighlight = function (node, highlights, nodeStart) {
  const toHighlight = getHighlightsToHighlight(node, highlights, nodeStart);

  if (!toHighlight.length) {
    return null;
  }

  const originalString = node.textContent.split("");
  let newString = "";

  const nodeEnd = nodeStart + originalString.length;

  toHighlight.filter(h => h["char_from"] < nodeStart).forEach((h) => {
    newString += `<mark data-mark-id="${h._id}">`;
  });

  for (let i = 0; i < originalString.length; i++) {
    toHighlight.filter(h => h["char_from"] === nodeStart + i).forEach((h) => {
      newString += `<mark data-mark-id="${h._id}">`;
    });

    toHighlight.filter(h => h["char_to"] === nodeStart + i - 1).forEach(() => {
      newString += "</mark>";
    });

    newString += originalString[i];
  }

  toHighlight.filter(h => h["char_to"] > nodeEnd).forEach(() => {
    newString += "</mark>";
  });

  return toNodes(`<span>${newString}</span>`);
};

export const getHighlightsToHighlight = (node, highlights = [], startOfNode) => {
  const endOfNode = startOfNode + node.textContent.length;

  return highlights.filter(h => {
    return (
      (h["char_from"] <= startOfNode && h["char_to"] >= endOfNode) ||
      (h["char_from"] >= startOfNode && h["char_from"] < endOfNode) ||
      (h["char_to"] >= startOfNode && h["char_to"] < endOfNode)
    );
  });
};

const doesNodeIncludeHighlights = (node, highlights, currentChar) => {
  const highlightsInNode = getHighlightsToHighlight(node, highlights, currentChar);

  return !!highlightsInNode.length;
};

export const countCharsUntilNode = (container, targetNode)  => {
  let charsNumber = 0;
  let foundNode = false;

  walkDOM(container, (node) => {
    if (node === targetNode) {
      foundNode = true;
      return;
    } else if (node.nodeName === "#text" && node.nodeValue !== "null") {
      if (!foundNode) {
        charsNumber += node.nodeValue.length;
      }
    }
  });

  return charsNumber;
};

export const addHighlights = (chapter, highlights = []) => {
  const highlightsInCurrentChapter = highlights.filter(h => h.chapter_id === chapter.id);

  if (!highlightsInCurrentChapter.length) {
    return chapter.text;
  }

  let bodyElement =  new DOMParser().parseFromString(chapter.text, "text/html").documentElement.children[1];
  let charCount = 0;

  walkDOM(bodyElement, (node) => {
    if (node.nodeName === "#text" && node.nodeValue !== "null") {
      const nodeLength = node.nodeValue.length;

      if (doesNodeIncludeHighlights(node, highlightsInCurrentChapter, charCount)) {
        const parentNode = node.parentNode;
        const newNode = splitAndHighlight(node, highlightsInCurrentChapter, charCount);

        parentNode.replaceChild(newNode, node);
      }

      charCount += nodeLength;
    }
  });
  return bodyElement.innerHTML;
};
